import { atom } from 'recoil'

/**
 * Controls whether the bathymetry layer is visible on the map.
 * Toggled by the LayerManager.
 */
export const bathymetryVisibleState = atom({
  key: 'bathymetryVisible',
  default: false,
})

/**
 * Set to false when the /maps API call for the bathymetry dfsu returns an error
 * (i.e. the Bathymetry.dfsu file does not exist for the current model).
 * Used by the LayerManager to disable the bathymetry toggle.
 */
export const bathymetryAvailableState = atom({
  key: 'bathymetryAvailable',
  default: true,
})

/**
 * The fetched bathymetry image in the same tuple format used by useBitmapLayers:
 * [timestep: string, base64Image: string, bounds: [north, east, south, west], { tStep: number }]
 *
 * Holds at most one entry (bathymetry is always timestep 0).
 */
export const bathymetryImagesState = atom({
  key: 'bathymetryImages',
  default: [],
})

/**
 * True while the bathymetry /maps request is in-flight.
 * Used by LayerManager to show an inline spinner instead of the global overlay.
 */
export const bathymetryLoadingState = atom({
  key: 'bathymetryLoading',
  default: false,
})
